
































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"])
})
export default class ChargeThrow extends Vue {
    @Prop({ type: Object })
    tableData?: Charge.ChargeRecord;

    // 保存
    save() {
        if (this.tableData) {
            Vue.axios
                .post(`charge/deletehistory`, {
                    id: this.tableData.id
                })
                .then(res => {
                    this.$emit("success");
                });
        }
    }
    close() {
        this.$emit("close");
    }
}
